import clsx from 'clsx';
import { createElement } from 'react';

import { EmblemList, Emblems } from './Emblems';

export type EmblemProps = {
  /**
   * Name of the emblem
   */
  name: EmblemList;
  /**
   * Size of the emblem
   */
  size?: 'small' | 'medium' | 'large';
  /**
   * Id of the title within the emblem
   */
  titleId?: string;
};

const sizeToSvgClassName: Record<NonNullable<EmblemProps['size']>, string> = {
  small: 'text-16',
  medium: 'text-24',
  large: 'text-[32px]',
};

export const Emblem = ({ name, size = 'medium', titleId }: EmblemProps) =>
  Emblems[name]
    ? createElement(Emblems[name], {
        preserveAspectRatio: 'xMidYMid meet',
        className: clsx(sizeToSvgClassName[size]),
        titleId,
      })
    : null;
